// extracted by mini-css-extract-plugin
export default {"header":"MyShops_header__SxjDk","container":"MyShops_container__ng6ng","title":"MyShops_title__Qe3rl","react_tabs_tab":"MyShops_react_tabs_tab__-HEBi","line":"MyShops_line__qNpBB"};